import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import CarHireBundledUpcomingOrder from './CarHireBundledUpcomingOrder'
import LayoutContainer from 'components/Common/LayoutContainer'
import { connect } from 'react-redux'
import LoadingBox from 'components/Common/Loading/LoadingBox'

interface Props {
  orders: Array<App.Order>
  title?: string
}

interface MappedProps {
  fetchingCarousels?: boolean
}

function CarHireBundledUpcomingOrders(props: Props & MappedProps) {
  const { orders, title, fetchingCarousels } = props

  const isFetching = fetchingCarousels || !orders.length

  return <Group direction="vertical" gap={24} desktopGap={40}>
    <LayoutContainer>
      {!!title && isFetching && <LoadingBox style={{ width: 1000, height: 34 }} />}
      {!!title && !isFetching && <Heading variant="heading2">{title}</Heading>}
    </LayoutContainer>
    {orders.map((order) => (
      <CarHireBundledUpcomingOrder key={order.id} order={order} />
    ))}
  </Group>
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  const ordersIds = ownProps.orders.map((order) => order.id)
  const allKeys = Object.keys(state.carHire.offerLists)

  return {
    fetchingCarousels: ordersIds.some((id) => {
      const key = allKeys.find((key) => key.includes(id))
      if (!key) return false
      return state.carHire.offerLists[key].fetching
    }),
  }
}

export default connect(mapStateToProps)(CarHireBundledUpcomingOrders)
